import React from 'react';
import { STATUS_META, TIER_META } from '../../../lib/aiInterviewApi';

export const Pill = ({ tone = 'slate', children, testId, title }) => (
  <span className={`iv-pill iv-tone-${tone}`} data-testid={testId} title={title}>{children}</span>
);

export const StatusPill = ({ status, testId }) => {
  const m = STATUS_META[status] || { label: (status || '').replace(/_/g, ' '), tone: 'slate' };
  return <Pill tone={m.tone} testId={testId}>{m.label}</Pill>;
};

export const TierPill = ({ tier = 'clear', score, testId }) => {
  const m = TIER_META[tier] || TIER_META.clear;
  return <Pill tone={m.tone} testId={testId}>{m.label}{typeof score === 'number' ? ` · ${score}` : ''}</Pill>;
};

export const REC_TONE = { 'Strong Yes': 'green', Yes: 'green', 'Lean No': 'amber', No: 'red' };
export const ADVISORY = { 'Strong Yes': 'Proceed', Yes: 'Proceed', 'Lean No': 'Borderline', No: 'Hold' };
export const RecPill = ({ rec, testId }) => (rec ? <Pill tone={REC_TONE[rec] || 'slate'} testId={testId}>{rec}</Pill> : <span className="iv-small">—</span>);

export const DECISION_LABEL = { advance: 'Advanced', bgv: 'Sent to BGV', reject: 'Rejected', hold: 'On hold' };
export const PROCTORING = { light: 'Light', standard: 'Standard', strict: 'Strict' };
export const LANGS = { en: 'English', hi: 'Hindi' };
export const SEV_COLOR = { info: '#3B82F6', low: '#94A3B8', medium: '#F59E0B', high: '#EF4444' };

export const parseIso = (iso) => (iso ? new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso}Z`) : null);
export const fmtDate = (iso, withTime = true) => {
  const d = parseIso(iso);
  if (!d) return '—';
  return d.toLocaleString(undefined, withTime ? { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' } : { day: 'numeric', month: 'short', year: 'numeric' });
};

export const Empty = ({ title, body, children, testId }) => (
  <div className="iv-card" style={{ textAlign: 'center', padding: '2.5rem 1.25rem' }} data-testid={testId}>
    <div style={{ fontWeight: 800, color: '#002A38' }}>{title}</div>
    {body && <p className="iv-small" style={{ maxWidth: 460, margin: '0.4rem auto 0' }}>{body}</p>}
    {children && <div style={{ marginTop: '1rem' }}>{children}</div>}
  </div>
);

export const Loading = ({ label = 'Loading…' }) => <div className="iv-small" style={{ padding: '2rem 0', textAlign: 'center' }} data-testid="iv-loading">{label}</div>;

export const Section = ({ title, right, children, testId, id }) => (
  <section className="iv-card" data-testid={testId} id={id}>
    {(title || right) && (
      <div className="iv-row" style={{ justifyContent: 'space-between', marginBottom: '0.75rem' }}>
        {title && <h2 className="iv-h2" style={{ margin: 0 }}>{title}</h2>}
        {right}
      </div>
    )}
    {children}
  </section>
);

export const copyText = async (text, toast) => {
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Link copied');
  } catch (e) {
    toast.message(text);
  }
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
